// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const requiredFirebaseKeys = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
];

const missingFirebaseKeys = requiredFirebaseKeys.filter(
  (key) => !String(firebaseConfig[key] || "").trim()
);

if (missingFirebaseKeys.length) {
  throw new Error(
    `Missing Firebase web config: ${missingFirebaseKeys.join(", ")}. Set VITE_FIREBASE_* values in the root .env file and restart Vite.`
  );
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Keep Firebase auth across reloads/tabs (best-effort; may be restricted in some environments).
setPersistence(auth, browserLocalPersistence).catch(() => {
  // Ignore persistence errors (e.g., browser restrictions).
});
export default app;
